import type { AppState } from '@console/reducers';
import type { LocalGifteeBoxTemplates } from '@console/reducers/gifteeBoxTemplates';

export const getGifteeBoxTemplates = (
  state: AppState
): LocalGifteeBoxTemplates => state.gifteeBoxTemplates;
